import { render } from "./RegisterVariableAdminComponent.vue?vue&type=template&id=b094aa24"
import script from "./RegisterVariableAdminComponent.vue?vue&type=script&lang=js"
export * from "./RegisterVariableAdminComponent.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__